document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector(".modal-promotion");
  const overlay = document.querySelector(".modal-promotion__overlay");
  const closeBtn = document.querySelector(".modal-promotion__close");
  const ctaBtn = document.querySelector(".modal-promotion__cta");

  if (!modal) return;

  const title = modal.querySelector(".modal-promotion__title");
  let lastTrigger = null;
  let isOpen = false;

  function focusableElements() {
    const sel = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';
    return Array.from(modal.querySelectorAll(sel)).filter(
      (el) => el.offsetParent !== null && !el.hasAttribute("inert")
    );
  }

  function onKeydown(evt) {
    if (!isOpen) return;
    if (evt.key === "Escape" || evt.keyCode === 27) {
      evt.preventDefault();
      closeModal();
      return;
    }
    if (evt.key === "Tab" || evt.keyCode === 9) {
      const focusables = focusableElements();
      if (!focusables.length) {
        evt.preventDefault();
        modal.focus();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      // The title has tabindex=-1 — if focus is parked there, pull it into the trap.
      if (!modal.contains(active) || active === title) {
        evt.preventDefault();
        (evt.shiftKey ? last : first).focus();
        return;
      }
      if (!evt.shiftKey && active === last) {
        evt.preventDefault();
        first.focus();
      } else if (evt.shiftKey && active === first) {
        evt.preventDefault();
        last.focus();
      }
    }
  }

  function openModal() {
    if (isOpen) return;
    isOpen = true;
    lastTrigger = document.activeElement;

    modal.classList.add("modal-promotion--active");
    modal.removeAttribute("aria-hidden");
    document.body.setAttribute("data-modal-promotion", "active");

    // Focus the title so the screen reader announces it, then trap the keyboard.
    const target = title || focusableElements()[0] || modal;
    window.requestAnimationFrame(function () {
      try { target.focus({ preventScroll: false }); } catch (e) { try { target.focus(); } catch (e2) {} }
    });
    document.addEventListener("keydown", onKeydown, true);
  }

  function closeModal() {
    if (!isOpen) return;
    isOpen = false;
    modal.classList.remove("modal-promotion--active");
    modal.setAttribute("aria-hidden", "true");
    document.body.removeAttribute("data-modal-promotion");
    document.removeEventListener("keydown", onKeydown, true);

    if (lastTrigger && typeof lastTrigger.focus === "function" && document.contains(lastTrigger)) {
      try { lastTrigger.focus(); } catch (e) { /* trigger may be detached */ }
    }
  }

  if (!sessionStorage.getItem("modalPromotionShown")) {
    setTimeout(() => {
      openModal();
      sessionStorage.setItem("modalPromotionShown", "true");
    }, 10000);
  }

  if (overlay) overlay.addEventListener("click", closeModal);
  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  if (ctaBtn) ctaBtn.addEventListener("click", closeModal);
});
